import { Feather } from "lucide-react";

import { cn } from "@/lib/utils";

/** Aviary wordmark — matches the public "the-aviary" site: a blue mark + a
 *  lowercase JetBrains Mono wordmark. */
export function Brand({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <span className="flex h-8 w-8 items-center justify-center rounded bg-primary text-primary-foreground">
        <Feather className="h-4 w-4" />
      </span>
      {!compact && (
        <span className="flex flex-col leading-tight">
          <span className="font-mono text-sm font-semibold tracking-tight text-foreground">
            the-aviary
          </span>
          <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            control plane
          </span>
        </span>
      )}
    </div>
  );
}
